import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SupplierDetailDialog from '../components/SupplierDetailDialog';
import { getSupplierResult } from '@/modules/suppliers/services/suppliers.service';
import '@/modules/suppliers/styles/suppliers.css';

export default function SupplierDetailPage() {
  const { supplierId } = useParams() || {};
  const navigate = useNavigate();
  const [supplier, setSupplier] = useState(null);
  const [status, setStatus] = useState('loading');
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    getSupplierResult(supplierId).then((result) => {
      if (!active) return;
      if (!result.ok) {
        setStatus(result.error === 'SUPPLIERS_MODULE_DISABLED' ? 'module_disabled' : 'unavailable');
        setError(result.message || 'Fornitore non disponibile.');
        return;
      }
      setSupplier(result.data);
      setStatus('available');
    });
    return () => {
      active = false;
    };
  }, [supplierId]);

  if (status === 'loading') {
    return <main className="supplier-detail"><div className="suppliers-empty">Caricamento dettaglio fornitore...</div></main>;
  }

  if (!supplier) {
    return <main className="supplier-detail"><div role="alert" className="suppliers-alert wt-inline-error">{error}</div></main>;
  }

  return (
    <main className="supplier-detail">
      <SupplierDetailDialog
        open
        supplier={supplier}
        onClose={() => navigate('/fornitori')}
      />
    </main>
  );
}
